import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Map, NavigationControl, GeoJSONSourceOptions, Marker, MapboxGeoJSONFeature, LngLat, Popup } from 'maplibre-gl';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import { Feature, Geometry } from 'geojson';
import { BoxService } from '../services/box.service';
import { PointerLocation } from '../types';

@Component({
  moduleId: module.id,
  //selector: 'app-my-map',
  selector: 'map-view',
  templateUrl: '../../Templates/box-map.component.html'
})
export class MyMapComponent implements AfterViewInit {

  @ViewChild('map')
  private mapContainer: ElementRef<HTMLElement>;

  private map: Map;
  //private boxId: number;
  private when: Date
  locations: PointerLocation[]
  private myAPIKey = 'a68cf69fedad464d9f3f9ca569088da7';
  private mapStyle = 'https://maps.geoapify.com/v1/styles/klokantech-basic/style.json';//`https://maps.geoapify.com/v1/styles/osm-carto/style.json`;
  private marker: Marker;
  selectedIndex: number = 0;
  @Input() boxId: number;
  @Input() set _when(_when: Date) {
    this.when = _when;
    var that = this;
    this.boxService.getBoxLocations(this.boxId, this.when).subscribe(locs => {
      that.locations = locs;
      that.map.on('style.load', function () {
        that.renderMap(0);
      });
    });
  }


  constructor(
    private route: ActivatedRoute,
    private boxService: BoxService
  ) { }

  //ngOnInit() {

  //  this.route.params
  //      .subscribe((params: Params) => {
  //        this.boxId = +params['id'];
  //        //this.getBoxAudits(this.boxid);
  //      }
  //    );
  //}
  renderMap(locationIndex: number) {
    var loc = this.locations[locationIndex];
    if (this.marker !== undefined) this.marker.remove();
    var airportIcon = document.createElement('div');
    airportIcon.classList.add("airport");
    airportIcon.style.backgroundImage = `url(https://api.geoapify.com/v1/icon/?type=awesome&scaleFactor=2&color=red&size=large&text=${locationIndex}&apiKey=${this.myAPIKey})`;
    airportIcon.classList.add("airport");
    var popup = new Popup({
      anchor: 'bottom',
      offset: [0, -64] // height - shadow
    })
      .setText(`${(new Date(loc._when)).toShortDateTimeString()}`);

    var marker = new Marker(airportIcon, {
      anchor: 'bottom',
      offset: [0, 6]
    })
      .setLngLat(loc.LngLat)
      .setPopup(popup)
      .addTo(this.map);
    this.marker = marker;
    this.map.setCenter(loc.LngLat).setZoom(10);
/*
    that.map.addSource('route', {
      'type': 'geojson',
      'data': {
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'LineString',
          'coordinates': that.locations.map(loc => loc.LngLat)
        }
      }
    });

    that.map.addLayer({
      'id': 'route',
      'type': 'line',
      'source': 'route',
      'layout': {
        'line-join': 'round',
        'line-cap': 'round'
      },
      'paint': {
        'line-color': '#888',
        'line-width': 3
      }
    });
*/
  }

  onClick(locIndex: number): void {
    this.selectedIndex = locIndex;
    this.renderMap(locIndex);
  }

  ngAfterViewInit() {

    const initialState = {
      lng: -0.12762,
      lat: 51.52792, // 52.633331, -1.133333 (leicster)
      zoom: 7
    };

    this.map = new Map({
      container: this.mapContainer.nativeElement,
      style: `${this.mapStyle}?apiKey=${this.myAPIKey}`,
      center: [initialState.lng, initialState.lat],
      zoom: initialState.zoom
    });
    this.map.addControl(new NavigationControl());
    var that = this;

    this.boxService.getBoxLocations(this.boxId, this.when).subscribe(locs => {
      that.locations = locs;
      that.map.on('style.load', function () {
        that.renderMap(0);
      });
    });
  }
}
